// Set once a TigerGraph account signs in on this browser, and cleared when a non-internal
// one does. It is the only identity signal available to pre-authentication events, which
// fire before any email is known. Kept out of analytics-service so modules that tests mock
// wholesale can still import it.
export const INTERNAL_USER_KEY = 'tg_analytics_internal_user';
